// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"Footer_footerContainer__187vn","separator":"Footer_separator__2ikR4"};